module.exports = __webpack_public_path__ + "static/media/wp-en-2.ed6d20dc.png";